import React, { useEffect, useState } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Lien magique de la démo : connexion directe (sans code), valable 30 jours.
 * URL : /demo-access?lead=<id>&t=<token>
 */
export default function DemoAccess() {
  const [error, setError] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const lead_id = params.get('lead');
    const token = params.get('t');

    if (!lead_id || !token) {
      setError("Lien invalide ou incomplet.");
      return;
    }

    (async () => {
      try {
        const res = await fetch(`${API}/api/demo-requests/magic`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ lead_id, token }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.detail || "Lien invalide ou expiré.");
        localStorage.setItem('token', data.access_token);
        localStorage.setItem('user', JSON.stringify(data.user));
        window.location.href = '/admin';
      } catch (err) {
        setError(err.message || "Impossible d'accéder à la démo.");
      }
    })();
  }, []);

  return (
    <div
      data-testid="demo-access-page"
      style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', background: '#0a1628', color: '#fff',
        fontFamily: "'Segoe UI', Arial, sans-serif", padding: 24, textAlign: 'center',
      }}
    >
      <div>
        <div style={{ fontSize: 24, fontWeight: 800, marginBottom: 16 }}>
          PitBoard<span style={{ color: '#0055a4' }}>.</span>
        </div>
        {error ? (
          <div data-testid="demo-access-error">
            <p style={{ color: '#fca5a5', margin: '0 0 16px' }}>{error}</p>
            <a href="/" style={{ color: '#60a5fa' }}>Retour au site</a>
          </div>
        ) : (
          <p data-testid="demo-access-loading" style={{ color: '#9ca3af' }}>
            Connexion à votre démo en cours…
          </p>
        )}
      </div>
    </div>
  );
}
